<v4-custom-select
  [placeholder]="'order.house_fee' | translate"
  [textItem]="textView"
  [showTextItem]="!!textView"
  [(visible)]="dropdownVisible"
>
  <div class="range-fee-picker-dropdown">
    <div class="dropdown-container">
      <div class="input-row">
        <input
          type="text"
          [(ngModel)]="start"
          nz-input
          [nzAutocomplete]="startAuto"
          [placeholder]="'guest.list.search_start' | translate"
        />
        <nz-autocomplete #startAuto>
          <nz-auto-option *ngFor="let opt of listOfStartOpt" [nzValue]="opt.value" [nzLabel]="opt.label">{{
            opt.label
          }}</nz-auto-option>
        </nz-autocomplete>
        <span class="seperate">~</span>
        <input
          type="text"
          [(ngModel)]="end"
          nz-input
          [nzAutocomplete]="endAuto"
          [placeholder]="'guest.list.search_end' | translate"
        />
        <nz-autocomplete #endAuto>
          <nz-auto-option *ngFor="let opt of listOfEndOpt" [nzValue]="opt.value" [nzLabel]="opt.label">{{
            opt.label
          }}</nz-auto-option>
        </nz-autocomplete>
      </div>
      <div class="bottom-row">
        <div class="left"></div>
        <div class="center">
          <button nz-button>
            {{ "word.cancel" | translate }}
            <!-- 取消 -->
          </button>
          <button nz-button nzType="primary" (click)="onConfirm()">
            {{ "word.confirm" | translate }}
            <!-- 确定 -->
          </button>
        </div>
        <div class="right">
          <a href="javascript:void(0)" (click)="onReset()">
            {{ "word.reset" | translate }}
            <!-- 重置筛选 -->
          </a>
        </div>
      </div>
    </div>
  </div>
</v4-custom-select>
